"use client";

import React from "react";
import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const families = [{
  id: 1,
  customerName: "The Miller Family",
  dogName: "Lady",
  year: "2023",
  quote: "Lady is the heart of our home. Her gentle nature and beautiful coat are a testament to the care at Mile High.",
  rating: 5,
  image: "https://milehighcavaliers.10web.cloud/wp-content/uploads/2026/03/Elise-and-Miss-Muffet-Puppy-.jpg?v=6s3srm0yu6n"
}, {
  id: 2,
  customerName: "James & Sarah",
  dogName: "Charlie",
  year: "2024",
  quote: "We couldn't have asked for a better experience. Charlie is healthy, happy, and so well-socialized from day one.",
  rating: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536339/img/happy_family_roxy.png"
}, {
  id: 3,
  customerName: "The Thompson's",
  dogName: "Beau",
  year: "2022",
  quote: "Beau is a stunning example of the breed. Everywhere we go, people comment on his regal look and sweet soul.",
  rating: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536339/img/happy_family_diesel.png"
}, {
  id: 4,
  customerName: "Grace L.",
  dogName: "Sophie",
  year: "2023",
  quote: "From the first application to bringing Sophie home, the process was seamless and filled with genuine love.",
  rating: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536339/img/happy_family_luna.png"
}, {
  id: 5,
  customerName: "Robert K.",
  dogName: "Oliver",
  year: "2024",
  quote: "Oliver has the perfect temperament. He's playful yet calm, exactly what we were looking for in a Cavalier.",
  rating: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536339/img/happy_family_buster.png"
}, {
  id: 6,
  customerName: "The Garcia Family",
  dogName: "Bella",
  year: "2022",
  quote: "Bella is our little shadow. The health testing and transparency provided gave us such incredible peace of mind.",
  rating: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536339/img/happy_family_tank.png"
}];
export default function HappyFamilies() {
  return <section data-section-id="152145" id="kind-words" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 md:mb-20 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight uppercase font-sans text-foreground">MILE HIGH CAVALIERS IN THE NEWS</h2>
          
          <div className="aspect-video w-full max-w-4xl mx-auto overflow-hidden">
            <iframe className="w-full h-full border-0" src="https://www.youtube.com/embed/tZ4zV1SV-Rg?start=8" title="Mile High Cavaliers in the News" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
          </div>

          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans"><br /></p>
        </div>

        {}
        <div className="block md:hidden">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {families.map((family, i) => <CarouselItem key={family.id} data-index={i} className="basis-full sm:basis-4/5">
                  <FamilyCard family={family} />
                </CarouselItem>)}
            </CarouselContent>
            <div className="flex justify-center gap-4 mt-12 relative h-12">
              <CarouselPrevious className="static translate-y-0 translate-x-0 border-primary border-[1px] bg-transparent text-primary rounded-none hover:bg-primary/5" />
              <CarouselNext className="static translate-y-0 translate-x-0 border-primary border-[1px] bg-transparent text-primary rounded-none hover:bg-primary/5" />
            </div>
          </Carousel>
        </div>

        {}
        <div className="hidden md:columns-2 lg:columns-3 gap-12 space-y-12">
          {families.map((family, i) => <div key={family.id} data-index={i} className="break-inside-avoid">
              <FamilyCard family={family} />
            </div>)}
        </div>
      </div>
    </section>;
}
function FamilyCard({
  family
}: {
  family: typeof families[0];
}) {
  return <Card className="overflow-hidden border-none bg-transparent shadow-none hover:shadow-lg transition-all duration-500 group rounded-none">
      <HoverCard>
        <HoverCardTrigger asChild>
          <div className="relative w-full pt-[100%] overflow-hidden cursor-pointer rounded-none">
            <img src={family.image} alt={`${family.customerName} with ${family.dogName}`} className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" />
            <div className="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
              <span className="text-xs font-sans tracking-[0.2em] text-primary-foreground uppercase bg-primary px-4 py-2 rounded-none">
                Our Story
              </span>
            </div>
          </div>
        </HoverCardTrigger>
        <HoverCardContent side="top" align="center" className="w-auto border-primary/20 bg-background/95 backdrop-blur-sm shadow-xl rounded-none">
          <div className="space-y-1 text-center px-4 py-2">
            <h4 className="text-base font-bold uppercase tracking-widest text-foreground font-sans">
              {family.dogName}
            </h4>
            <p className="text-xs text-muted-foreground font-sans uppercase tracking-tighter">
              Adopted {family.year}
            </p>
          </div>
        </HoverCardContent>
      </HoverCard>

      <CardContent className="py-8 px-0 flex flex-col gap-6">
        <div className="flex gap-1 text-primary justify-center">
          {[...Array(family.rating)].map((_, i) => <Star key={i} data-index={i} className="w-3 h-3 fill-current" />)}
        </div>
        <blockquote className="text-foreground text-2xl leading-snug italic font-sans text-center px-4">
          "{family.quote}"
        </blockquote>
        <div className="mt-auto pt-6 text-center">
          <p className="font-bold text-foreground tracking-widest uppercase text-sm font-sans">
            {family.customerName}
          </p>
          <p className="text-xs text-primary mt-1 font-sans uppercase tracking-widest">
            {family.dogName}'s Family
          </p>
        </div>
      </CardContent>
    </Card>;
}